import { GET_ACCOUNT_ID_LIST_FAILED, GET_ACCOUNT_ID_LIST_SUCCESS, LOADING_GET_ACCOUNT_ID_LIST, NETWORK_ERROR_GET_ACCOUNT_ID_LIST, RESET_GET_ACCOUNT_ID_LIST } from "../types"

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: '',
    networkError: '', 
}

export const getAccountIdList = ( state = initialState, { type, payload } ) => {
    switch( type ) {
        case LOADING_GET_ACCOUNT_ID_LIST:{
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: '',
                networkError: '',
            }
        }
        case GET_ACCOUNT_ID_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        }
        case GET_ACCOUNT_ID_LIST_FAILED: {
            return {
                ...state, 
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        }
        case NETWORK_ERROR_GET_ACCOUNT_ID_LIST: {
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: payload,
                message: "",
                networkError: "",
            }
        }
        case RESET_GET_ACCOUNT_ID_LIST: {
            return ( state = initialState );
        }
        default:
            return state;
    }
}